import { Base } from '../../../base/components/base'
import { Div } from '../../../base/components/native/div'
import device from '../../../base/helpers/device'
import { EASE } from '../../../base/helpers/style'
import ldb from '../../../base/lib/ldb'
import router, { IRouteParams } from '../../../base/lib/router'
import emitter from '../../../base/utils/emitter'
import { waitFor } from '../../../base/utils/wait'
import helpers from '../../../helpers'
import db from '../../../services/db'
import { HistoryItem } from './history-item'


export const HistoryPage = () => {

    const base = Base()
    const contents = Div()
    const title = Div('Previous designs')
    const list = Div()
    contents.append(title, list)
    base.append(contents)


    base.cssClass(helpers.styles.PAGE_BASE_STYLE)
    title.cssClass({ margin: '0 0 21px 0' })
    list.cssClass({
        fontSize: '16px'
    })
    contents.cssClass({
        fontSize: '20px',
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingLeft: '70px',
        paddingBottom: '50px',
        paddingTop: '20px',
        paddingRight: '50px',
        color: 'white',
    })

    emitter.on('synced', render)
    async function render() {
        const history = await db.find('history')
        list.empty()
        history.map((item: any) => {
            const historyItem = HistoryItem(item)
            list.append(historyItem)
        })
    }
    return {
        ...base,
        async exit({ to = '' }: IRouteParams) {
            base.style(helpers.styles.PAGE_EXIT_STYLE)
        },
        async enter({ from = '' }: IRouteParams) {

            if (device.isMobile()) await waitFor(200)
            if (from === '/') {
                base.style({ ...helpers.styles.PAGE_EXIT_STYLE, ...EASE(0) })
            }
            base.style({ ...helpers.styles.PAGE_ENTER_STYLE, ...EASE(.16) }, 50)
            render()

        }
    }
}